import Steps from './Steps';
import Step from './Step';

export { Step };
export default Steps;
